<template>
    <div
        class="cell example example2"
    >
        <form
            v-if="entryForm"
            v-on:submit="formSubmitted"
            id="payment-form"
            :class="loading ? 'is_loading' : '' "
        >
            <div class="">
                <h3
                    class="text-3xl font-bold text-gray-500"
                >
                    Enter Your Best Cover Image!
                </h3>
                <div
                    v-if="loggedOut"
                    class="my-2"
                >
                    *Please <span class="cursor-pointer font-semibold underline hover:text-blue-500" @click="toggleLoginPopup">register or sign in</span> to complete your entry
                </div>
            </div>
            <div>
                <div
                    class="image-field mb-5"
                >
                    <label class="file-label">
                        Upload Image <span class="red">*</span> - <router-link :to="`/contests/${contest.slug}/help`" class="underline">Photo Tips</router-link>
                    </label>
                    <div>
                        For a cover image, vertical photos work best. Submit photos in high-resolution.
                    </div>
                    <div class="d-block">
                        <input
                            id="upload"
                            ref="upload"
                            type="file"
                            accept="image/jpeg"
                            v-on:change="handleImageUploadChange"
                            v-on:click="(event)=> {
                              event.target.value = null
                            }"
                        />
                    </div>
                    <div
                        id="covered-image"
                        v-if="entryForm && imageSrc"
                        style="max-width: 587px;"
                    >
                        <img
                            id="user-image"
                            :src="imageSrc"
                        />
                        <img
                            class="relative"
                            v-if="contest && contest.type === 'cover_search_contest'"
                            src='/images/cover_template_new.png'
                        />
                    </div>
                </div>
                <div
                    class="input-errors"
                    :class="{ 'text-red-500': v$.entryForm.image.value.$error }"
                    v-for="error of v$.entryForm.image.value.$errors"
                    :key="error.$uid"
                >
                    <div class="error-msg">{{ error.$message }}</div>
                </div>
                <input-text-field
                    :vuelidate="v$.entryForm.item_name"
                    id="item_name"
                    label="Name of Location or Image"
                    :value="entryForm.item_name"
                    @input="(e) => handleInput(e, 'item_name')"
                ></input-text-field>
                <input-text-field
                    :vuelidate="v$.entryForm.meta.location"
                    id="location"
                    label="City Image Taken (photo must be taken in New Jersey)"
                    :value="entryForm.meta.location"
                    @input="(e) => handleSubInput(e, 'meta', 'location')"
                ></input-text-field>
                <input-date-field
                    :vuelidate="v$.entryForm.item_att2"
                    id="item_att2"
                    label="Date Image Taken"
                    :value="entryForm.item_att2"
                    @input="(e) => handleInput(e, 'item_att2')"
                ></input-date-field>
                <input-text-field
                    :vuelidate="v$.entryForm.item_att3"
                    id="item_att3"
                    label="Camera or Device Make/Model"
                    :value="entryForm.item_att3"
                    @input="(e) => handleInput(e, 'item_att3')"
                ></input-text-field>
                <div
                    class="mb-5"
                >
                    <div
                        class="textarea"
                    >
                        <label for="item-description" class="form-check-label textarea">
                            Image Description
                            <span
                                class="red"
                            >
                                *
                            </span>
                        </label>
                        <textarea
                            v-model="entryForm.item_description"
                            @blur="v$.entryForm.item_description.$touch"
                            required
                            id="item-description"
                            name="item_description"
                            type="text"
                            placeholder="limit of 600 characters"
                        />
                        <div class="baseline"></div>
                    </div>
                    <div
                        class="input-errors"
                        :class="{ 'text-red-500': v$.entryForm.item_description.$error }"
                        v-for="error of v$.entryForm.item_description.$errors"
                        :key="error.$uid"
                    >
                        <div class="error-msg">{{ error.$message }}</div>
                    </div>
                </div>
                <!-- Photo Permission -->
                <checkbox-field
                    :vuelidate="v$.entryForm.photo_permission"
                    id="photo_permission"
                    label="Photo Permission"
                    :value="entryForm.photo_permission"
                    @change="(e) => handleCheckboxInput(e, 'photo_permission')"
                ></checkbox-field>
                <!-- Student checkbox -->
                <checkbox-field
                    :vuelidate="v$.entryForm.is_student"
                    id="is_student"
                    label="Student Photograph?"
                    :value="entryForm.is_student"
                    @change="(e) => handleCheckboxInput(e, 'is_student')"
                ></checkbox-field>
                <div
                    v-show="entryForm.is_student"
                >
                    <input-text-field
                        :vuelidate="v$.entryForm.meta.student_age"
                        id="student_age"
                        label="Student Age"
                        :value="entryForm.meta.student_age"
                        @input="(e) => handleSubInput(e, 'meta', 'student_age')"
                    ></input-text-field>
                    <input-text-field
                        :vuelidate="v$.entryForm.meta.student_grade"
                        id="student_grade"
                        label="Student Grade"
                        :value="entryForm.meta.student_grade"
                        @input="(e) => handleSubInput(e, 'meta', 'student_grade')"
                    >
                    </input-text-field>
                    <div
                        class="text-red-600 mb-3"
                    >
                        <div
                            class="mb-2"
                        >
                            Full-time students age 25 and under are eligible.
                        </div>
                        <div>
                            Warning: you must be a student to submit a student entry. If you are not a student and submit a student entry, you will be disqualified.
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="text-center full-width"
                v-on:click="formSubmitted"
            >
                <span class="scroll btn btn-primary">
                    {{ entry.id ? 'Update' : 'Next Step' }}
                </span>
            </div>
        </form>
    </div>
</template>

<script>
import {API_URL, S3_URL, ENV_URL} from '../../environment.js';
import { email, required, requiredIf, minLength, maxLength, sameAs, helpers } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import InputTextField from "@/js/components/fields/vuelidate/InputTextField";
import CheckboxField from "@/js/components/fields/vuelidate/CheckboxField";
import InputDateField from "@/js/components/fields/vuelidate/InputDateField";
import {isEmpty} from "lodash";

const notRequired = () => true;

export default {
    props: ['id', 'category'],
    setup () {
        return { v$: useVuelidate() }
    },
    components: {
        InputTextField,
        CheckboxField,
        InputDateField,
    },
    mounted () {
        // for (let key in this.prefillTestData) {
        //     this.entryForm[key] = this.prefillTestData[key];
        // }
        if (this.entryForm && this.entryForm.item_att1 === 'Student') {
            this.entryForm.is_student = true;
        }
    },
    data() {
        return {
            open: true,
            S3_URL: S3_URL,
            update: false,
            count: 1,
            makingRequest: false,
            prefillTestData: {
                image: {
                    value: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQIW2Nw+xDxHwAFnAKOyRKGeAAAAABJRU5ErkJggg==',
                },
                item_name: 'Item Name',
                meta: {
                    location: 'Morristown',
                    student_age: '12',
                    student_grade: '12th',
                },
                item_att2: '2022-12-22',
                item_att1: true,
                item_description: 'item description',
                item_att3: 'Canon',
                photo_permission: 0,
            }
        }
    },
    validations () {
        let validationsObject = {};
        return {
            entryForm: {
                image: {
                    value: {
                        required: requiredIf(() => isEmpty(this.entryForm.main_image.full))
                    }
                },
                item_name: { required },
                item_att2: { required },
                is_student: {
                    notRequired,
                },
                meta: {
                    location: { required },
                    student_age: {
                        required: requiredIf(function() {return this.entryForm.is_student})
                    },
                    student_grade: {
                        required: requiredIf(function() {return this.entryForm.is_student})
                    },
                },
                item_description: { required: helpers.withMessage('This field cannot be blank. It must be between 1 and 600 characters.', required), maxLength: maxLength(600) },
                item_att3: { required },
                photo_permission: {
                    sameAs: helpers.withMessage('Permission to use photo must be checked.', sameAs( 1 )),
                    required,
                },
            }
        }
    },
    computed: {
        entryForm () {
            return this.$store.state.entryForm;
        },
        imageSrc () {
            if (this.entryForm.image.value) {
                return this.entryForm.image.value;
            }
            if (this.entryForm.main_image) {
                return this.entryForm.main_image.large;
            }
            return '';
        },
        contest() {
            return this.$store.state.contest;
        },
        currentCategory() {
            const categoryMap = {
                'northern-new-jersey': 'Northern New Jersey',
                'southern-new-jersey': 'Southern New Jersey',
                'central-nj': 'Central New Jersey',
                'down-the-shore': 'Down The Shore',
                'historic-sites': 'Historic Sites',
                'take-a-hike': 'Take A Hike'
            }
            let cat = this.$props.category;
            return categoryMap[cat];
        },
        loading() {
            return this.$store.state.loading;
        },
        entry() {
            return this.$store.state.entry;
        },
        selectedSingleCategories() {
            return this.$store.state.selectedSingleCategories;
        },
        selectSingleCategories() {
            return this.$store.state.selectSingleCategories;
        },

        user() {
            return this.$store.state.user;
        },
        loggedOut () {
            return isEmpty(this.user);
        },
    },

    methods: {
        handleImageUploadChange(e) {
            // add the uploaded image to the input
            const reader = new FileReader();
            const file = e.target.files[0];
            const file_size = file.size;
            if (file_size > 10000000) {
                alert('Your file is too big (' + file_size / 1000000 + 'mb). Please upload an image less than 10mb.');
                return;
            }
            reader.onload = (upload) => {
                var img = new Image();
                img.src = reader.result;
                img.onload = function (e) {
                    this.entryForm.image.value = upload.target.result;
                    this.entryForm.image.filename = file.name;
                    this.entryForm.image.filetype = file.type;
                    // this.$store.dispatch('ENTRY_FORM', {entryForm: form});
                }.bind(this);
            };
            reader.readAsDataURL(file);
        },
        setNameIfEmpty() {
            let item_name = document.getElementById('item_name');
            if (item_name) {
                let category = this.$route.query.cat;
                item_name.value = category != '' && item_name.value.trim() === "" && item_name.required === false ? category : item_name.value;
                return item_name.value;
            }
        },
        toggleLoginPopup () {
            this.$store.dispatch('TOGGLE_LOGIN_POPUP');
        },
        handleInput(e, field) {
            this.$store.commit('setObjectState', {
                obj: 'entryForm',
                key: field,
                data: e.target.value,
            })
        },
        handleCheckboxInput(e, field) {
            this.$store.commit('setObjectState', {
                obj: 'entryForm',
                key: field,
                data: e.target.checked ? 1 : 0,
            })
        },
        handleSubInput(e, subObj, field) {
            this.$store.commit('setSubObjectState', {
                obj: 'entryForm',
                subObj,
                key: field,
                data: e.target.value,
            })
        },
        formSubmitted(e) {
            e.preventDefault();
            // require users to sign in or register to submit
            if (this.loggedOut) {
                this.$store.state.modal.title = 'Please login or register to continue';
                this.toggleLoginPopup();
                return;
            }
            this.v$.$touch();
            if (this.v$.$error) {
                return;
            }
            this.$store.state.entryForm = this.entryForm;
            this.$emit('submitted');
        },
    },
}
</script>

<style lang="scss" scoped>
.v-select .dropdown-menu {
    text-transform: capitalize;
}

#covered-image {
    position: relative;
    overflow: hidden;
}

#user-image {
    position: absolute;
}

.v-select.single .selected-tag {
    text-transform: capitalize;
}

.category {
    font-size: 1.3em;
}
</style>
